import React, { FC } from 'react'
import { useNavigate } from 'react-router-dom'


import { Text, TextName } from 'sdk'
import { Button } from 'sdk/button/Button'
import { Pill } from 'sdk/pill/Pill'
import BlueGridContainer from 'components/blue-grid-container/BlueGridContainer'

import { HomePartnerProgramCmsContent } from 'core/services/cms/interfaces'

import classes from './style.module.scss'

interface PartnerProgramFeatureSectionProps {
  content: HomePartnerProgramCmsContent
}

export const PartnerProgramFeatureSection: FC<PartnerProgramFeatureSectionProps> = ({ content }) => {
  const navigate = useNavigate()

  const handleButtonClick = (): void => {
    if (/^(https?:\/\/|mailto:|tel:)/.test(content.buttonUrl)) {
      window.location.assign(content.buttonUrl)
      return
    }

    navigate(content.buttonUrl)
  }

  return (
    <BlueGridContainer>
      <div className={classes.content}>
        <Text type={TextName.H1} className={classes.title}>
          {content.title}
        </Text>
        <Text type={TextName.Text} className={classes.subtitle}>
          {content.subtitle}
        </Text>
        <div className={classes.pillsContainer}>
          {content.pillItems.map((text, index) => (
            <Pill key={index} text={text} variant='outline' />
          ))}
        </div>
      </div>
      <div className={classes.buttonContainer}>
        <Button variant='blurred' as='button' onClick={handleButtonClick}>
          {content.buttonText}
        </Button>
      </div>
    </BlueGridContainer>
  )
}
